import { SlotSearchParams, GetPaginationInfoResponse } from '../../Model/Slot';
import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';

export class GetSlotsPaginationInfoUseCase {
  constructor(private repo: SlotRepository) {}

  execute(current: User | null, params?: SlotSearchParams): Promise<GetPaginationInfoResponse> {
    // SELLER 권한인 경우 user 파라미터 추가
    const searchParams: SlotSearchParams = {
      ...params,
      ...(current && current.grade === 'SELLER' ? { sellerId: current.id } : {})
    };

    return this.repo.getPaginationInfo(searchParams);
  }
} 